//import router from "@/router";
import Cookies from "js-cookie";
import { getUrlParams, initLocalName, decodeAdvanced } from "@/utils";

const state = {
  API_TOKEN:
    process.env.NODE_ENV == "development" ? process.env.VUE_APP_API_TOKEN : "", //getToken(),
  name: "", //用户名
  loginInfo: {}, //登陆后的信息
  SHowMainHead: false, // 是否显示主页面中的头部栏
  SHowTopHead: true, //是否显示系统顶部栏
  selectedType: getUrlParams("selected_type")
    ? getUrlParams("selected_type")
    : "keywords", // 页面顶部下拉框中选中的 搜索范围
  brandName: initLocalName(
    getUrlParams("brand_id") ? getUrlParams("brand_id").split(",") : [],
    localStorage.getItem("brandName")
      ? JSON.parse(localStorage.getItem("brandName"))
      : []
  ), // 页面顶部下拉框中选中的品牌类型名称
  selectedKeyWords: getUrlParams("word") ? getUrlParams("word") : "", //页面顶部输入框中输入的搜索条件
  catId: getUrlParams("cat_id") ? getUrlParams("cat_id") : "", //选择的类目ID
  catName:
    getUrlParams("cat_id") && getUrlParams("cat_name")
      ? getUrlParams("cat_name")
      : "", //选择的类目名称
  ruleId: getUrlParams("rule_id") ? getUrlParams("rule_id") : "", //规则ID
  analyseTyp: getUrlParams("analyse_typ") ? getUrlParams("analyse_typ") : "", //规则名称
  routerRuleId: getUrlParams("r_rule_id") ? getUrlParams("r_rule_id") : "", //头部筛选条件的规则ID
  routerAnalyseTyp: getUrlParams("r_analyse_typ")
    ? getUrlParams("r_analyse_typ")
    : "", //头部筛选条件的规则名称
  words: getUrlParams("words") ? getUrlParams("words") : "", //头部筛选条件选中声量图表数据的名称
  issue_id: getUrlParams("issue_id") ? getUrlParams("issue_id") : "", //头部筛选条件选中工单号
  labelLevel: getUrlParams("label_level") ? getUrlParams("label_level") : "", //头部筛选条件选中声量的等级
  aspectType: getUrlParams("aspect_type") ? getUrlParams("aspect_type") : "", //头部筛选条件选中声量的类型(全部,正向,负向)
  kolType: getUrlParams("kol_type")
    ? getUrlParams("kol_type").split(",")
    : ["consumer", "kol"], //选择的作者
  plants: getUrlParams("plat")
    ? getUrlParams("plat").split(",")
    : ["douyin", "weibo", "xhs"], //选择的平台
  KolId: getUrlParams("kol_id") ? getUrlParams("kol_id") : "", //选择的达人ID
  KolName: getUrlParams("kol_name") ? getUrlParams("kol_name") : "", //选择的达人名称
  post_kolId: "", //帖子达人榜ID
  post_KolName: "", //帖子达人榜名称
  startMonth: getUrlParams("start") ? getUrlParams("start") : "", //开始月份
  endMonth: getUrlParams("end") ? getUrlParams("end") : "", //结束月份
  //logingState: true, //登陆过状态 false:未登录  true:已登录
  ActivedMnenue: "1-1", //当前选中的menue
  ActivedTab: getUrlParams("passActivedTab")
    ? getUrlParams("passActivedTab")
    : "BaseInfo", //当前选中的tab
  CloudWord: getUrlParams("CloudWord") ? getUrlParams("CloudWord") : "", //选中的次云 用于查询帖子列表
  brand_id2: getUrlParams("postBrandId") ? getUrlParams("postBrandId") : "", //用于查询帖子列表
  post_brand_name: getUrlParams("postBrandName")
    ? getUrlParams("postBrandName")
    : "", // 用于查询帖子列表
  user_id: getUrlParams("user_id") ? getUrlParams("user_id") : "",
  client_id: getUrlParams("client_id") ? getUrlParams("client_id") : "",
  sign: getUrlParams("sign") ? getUrlParams("sign") : "",
  pm_id: getUrlParams("pm_id") ? getUrlParams("pm_id") : "",
  post_download: false, //是否展示帖子原文下载按钮
  navContent: [], //nav的tab数据
  cf_selected_type: getUrlParams("cf_selected_type")
    ? decodeAdvanced(getUrlParams("cf_selected_type"))
    : [], //头部多筛选条件类型
  cf_word: getUrlParams("cf_word")
    ? decodeAdvanced(getUrlParams("cf_word"))
    : [], //头部多筛选条件输入内容
};

const mutations = {
  SET_API_TOKEN: (state, data) => {
    state.API_TOKEN = data;
  },
  SET_SHOW_MAIN_HEAD: (state, data) => {
    state.SHowMainHead = data;
  },
  SET_SHOW_TOP_HEAD: (state, data) => {
    state.SHowTopHead = data;
  },
  SET_SELECTED_TYPE: (state, data) => {
    state.selectedType = data;
  },
  SET_SELECTED_NAME: (state, data) => {
    state.brandName = data;
  },
  SET_LOGININFO: (state, data) => {
    state.loginInfo = data;
  },
  SET_SELECTED_KeyWords: (state, data) => {
    state.selectedKeyWords = data;
  },
  SET_KOL_TYPE: (state, data) => {
    state.kolType = data;
  },
  SET_PLANTS: (state, data) => {
    state.plants = data;
  },
  SET_CAT_ID: (state, data) => {
    state.catId = data;
  },
  SET_CAT_NAME: (state, data) => {
    state.catName = data;
  },
  SET_RULE_ID: (state, data) => {
    state.ruleId = data;
  },
  SET_ROUTER_RULE_ID: (state, data) => {
    state.routerRuleId = data;
  },
  SET_ROUTER_WX_UID: (state, data) => {
    state.wx_uid = data;
  },
  SET_ANALYSE_TYP: (state, data) => {
    state.analyseTyp = data;
  },
  SET_ROUTER_ANALYSE_TYP: (state, data) => {
    state.routerAnalyseTyp = data;
  },
  SET_WORDS: (state, data) => {
    state.words = data;
  },
  SET_ISSUE_ID: (state, data) => {
    state.issue_id = data;
  },
  SET_LABEL_LEVEL: (state, data) => {
    state.labelLevel = data;
  },
  SET_ASPECT_TYPE: (state, data) => {
    state.aspectType = data;
  },
  SET_KOL_ID: (state, data) => {
    state.KolId = data;
  },
  SET_KOL_NAME: (state, data) => {
    state.KolName = data;
  },
  SET_POST_KOL_ID: (state, data) => {
    state.post_kolId = data;
  },
  SET_POST_KOL_NAME: (state, data) => {
    state.post_KolName = data;
  },
  SET_START_MONTH: (state, data) => {
    state.startMonth = data;
  },
  SET_END_MONTH: (state, data) => {
    state.endMonth = data;
  },
  SET_ACTIVED_MENUE: (state, data) => {
    state.ActivedMnenue = data;
  },
  SET_ACTIVED_TAB: (state, data) => {
    state.ActivedTab = data;
  },
  SET_CLOUD_WORD: (state, data) => {
    state.CloudWord = data;
  },
  SET_BRAND_ID2: (state, data) => {
    state.brand_id2 = data;
  },
  SET_POST_BRAND_NAME: (state, data) => {
    state.post_brand_name = data;
  },
  SET_IDS: (state, data) => {
    state.ids = data;
  },
  SET_USER_ID: (state, data) => {
    state.user_id = data;
  },
  SET_CLIENT_ID: (state, data) => {
    state.client_id = data;
  },
  SET_SIGN: (state, data) => {
    state.sign = data;
  },
  SET_PM_ID: (state, data) => {
    state.pm_id = data;
  },
  SET_POST_DOWNLOAD: (state, data) => {
    state.post_download = data;
  },
  SET_NAV_CONTENT: (state, data) => {
    state.navContent = data;
  },
  SET_CF_SELECTED_TYPE: (state, data) => {
    state.cf_selected_type = data;
  },
  SET_CF_WORD: (state, data) => {
    state.cf_word = data;
  },
};

const actions = {
  changeApiToken({ commit, dispatch }, data) {
    commit("SET_API_TOKEN", data);
  },
  changeShowMainHead({ commit, dispatch }, data) {
    commit("SET_SHOW_MAIN_HEAD", data);
  },
  changeShowTopHead({ commit, dispatch }, data) {
    commit("SET_SHOW_TOP_HEAD", data);
  },
  changeLoginInfo({ commit, dispatch }, data) {
    commit("SET_LOGININFO", data);
  },
  changeSelectedType({ commit, dispatch }, data) {
    commit("SET_SELECTED_TYPE", data);
  },
  changeBrandName({ commit, dispatch }, data) {
    commit("SET_SELECTED_NAME", data);
  },
  changeselectedKeyWords({ commit, dispatch }, data) {
    commit("SET_SELECTED_KeyWords", data);
  },
  changeKolType({ commit, dispatch }, data) {
    commit("SET_KOL_TYPE", data);
  },
  changeplants({ commit, dispatch }, data) {
    commit("SET_PLANTS", data);
  },
  changeCatId({ commit, dispatch }, data) {
    commit("SET_CAT_ID", data);
  },
  changeCatName({ commit, dispatch }, data) {
    commit("SET_CAT_NAME", data);
  },
  changeAnalyseTyp({ commit, dispatch }, data) {
    commit("SET_ANALYSE_TYP", data);
  },
  changeRouterAnalyseTyp({ commit, dispatch }, data) {
    commit("SET_ROUTER_ANALYSE_TYP", data);
  },
  changeWords({ commit, dispatch }, data) {
    commit("SET_WORDS", data);
  },
  changeIssueId({ commit, dispatch }, data) {
    commit("SET_ISSUE_ID", data);
  },
  changeLabelLevel({ commit, dispatch }, data) {
    commit("SET_LABEL_LEVEL", data);
  },
  changeAspectType({ commit, dispatch }, data) {
    commit("SET_ASPECT_TYPE", data);
  },
  changeRuleId({ commit, dispatch }, data) {
    commit("SET_RULE_ID", data);
  },
  changeRouterRuleId({ commit, dispatch }, data) {
    commit("SET_ROUTER_RULE_ID", data);
  },
  changeRouterWxuid({ commit, dispatch }, data) {
    commit("SET_ROUTER_WX_UID", data);
  },
  changeKolId({ commit, dispatch }, data) {
    commit("SET_KOL_ID", data);
  },
  changeKolName({ commit, dispatch }, data) {
    commit("SET_KOL_NAME", data);
  },
  changePostKolId({ commit, dispatch }, data) {
    commit("SET_POST_KOL_ID", data);
  },
  changePostKolName({ commit, dispatch }, data) {
    commit("SET_POST_KOL_NAME", data);
  },
  changeStartMonth({ commit, dispatch }, data) {
    commit("SET_START_MONTH", data);
  },
  changeEndMonth({ commit, dispatch }, data) {
    commit("SET_END_MONTH", data);
  },
  changeActivedMnenue({ commit, dispatch }, data) {
    commit("SET_ACTIVED_MENUE", data);
  },
  changeActivedTab({ commit, dispatch }, data) {
    commit("SET_ACTIVED_TAB", data);
  },
  changeCloudWord({ commit, dispatch }, data) {
    commit("SET_CLOUD_WORD", data);
  },
  changeBrandId2({ commit, dispatch }, data) {
    commit("SET_BRAND_ID2", data);
  },
  changePostBrandName({ commit, dispatch }, data) {
    commit("SET_POST_BRAND_NAME", data);
  },
  changeIds({ commit, dispatch }, data) {
    commit("SET_IDS", data);
  },
  changeUserId({ commit, dispatch }, data) {
    commit("SET_USER_ID", data);
  },
  changeClientId({ commit, dispatch }, data) {
    commit("SET_CLIENT_ID", data);
  },
  changeSign({ commit, dispatch }, data) {
    commit("SET_SIGN", data);
  },
  changePmId({ commit, dispatch }, data) {
    commit("SET_PM_ID", data);
  },
  changePostDownload({ commit, dispatch }, data) {
    commit("SET_POST_DOWNLOAD", data);
  },
  changeNavContent({ commit, dispatch }, data) {
    commit("SET_NAV_CONTENT", data);
  },
  changeCfSelectedType({ commit, dispatch }, data) {
    commit("SET_CF_SELECTED_TYPE", data);
  },
  changeCfWord({ commit, dispatch }, data) {
    commit("SET_CF_WORD", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
